import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { roleGuard } from './guards/AuthGuard';
import { LoadingSpinner } from './styles/components/ModernComponents';

// Auth Components
const Login = React.lazy(() => import('./components/auth/Login'));

// Support Admin Layout
const SupportAdminLayout = React.lazy(() => import('./components/support-admin/SupportAdminLayout'));

// Support Admin Components
const SupportDashboard = React.lazy(() => import('./components/support-admin/SupportDashboard'));
const SupportAccountList = React.lazy(() => import('./components/support-admin/accounts/SupportAccountList'));
const SupportUserList = React.lazy(() => import('./components/support-admin/users/SupportUserList'));
const SupportProjectList = React.lazy(() => import('./components/support-admin/projects/SupportProjectList'));
const SupportReleaseTopicsList = React.lazy(() => import('./components/support-admin/release-topics/SupportReleaseTopicsList'));

export default function AppRoutes(props: any): React.ReactElement {
  const routes = createBrowserRouter([
    {
      path: 'auth/login',
      element: (
        <Suspense fallback={<LoadingSpinner />}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: 'support',
      element: (
        <Suspense fallback={<LoadingSpinner />}>
          <SupportAdminLayout />
        </Suspense>
      ),
      loader: roleGuard.protectedLoader,
      children: [
        {
          path: 'dashboard',
          element: (
            <Suspense fallback={<LoadingSpinner />}>
              <SupportDashboard />
            </Suspense>
          ),
        },
        {
          path: 'accounts',
          element: (
            <Suspense fallback={<LoadingSpinner />}>
              <SupportAccountList />
            </Suspense>
          ),
        },
        {
          path: 'accounts/:accountId/users',
          element: (
            <Suspense fallback={<LoadingSpinner />}>
              <SupportUserList />
            </Suspense>
          ),
        },
        {
          path: 'accounts/:accountId/projects',
          element: (
            <Suspense fallback={<LoadingSpinner />}>
              <SupportProjectList />
            </Suspense>
          ),
        },
        {
          path: 'accounts/:accountId/projects/:projectId/release-topics',
          element: (
            <Suspense fallback={<LoadingSpinner />}>
              <SupportReleaseTopicsList />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: '',
      element: <Navigate to="/auth/login" />,
    },
    {
      path: '*',
      element: <Navigate to="/auth/login" />,
    },
  ]);

  return <RouterProvider router={routes} />;
}
